import { toast } from "react-toastify";

export const handleApiError = (error, displayMessage) => {
    if(error.response.status !== 401) toast.error(displayMessage);
}